<template>
  <div class="c-form-popup-wrap" v-show="showForm == true">
    <div class="c-form-popup-container">
      <div class="c-form-popup-close" v-on:click="showForm = false">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
            <path fill="none" d="M0 0h32v32H0z"/>
            <path d="M16.2 15.5l5.1-5.1c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0l-5.1 5.1-5.1-5.1c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l5.1 5.1-5.1 5.1c-.2.2-.2.5 0 .7.1.1.2.1.4.1.1 0 .3 0 .4-.1l5.1-5.1 5.1 5.1c.1.1.2.1.4.1s.3 0 .4-.1c.2-.2.2-.5 0-.7l-5.3-5.1z"/>
        </svg>
      </div>
      <h2 v-if="send == false">Wypełnij formularz kontaktowy</h2>
      <h2 v-if="send != false">Dziękujemy za zainteresowanie.<br />Nasz doradca skontaktuje się z Państwem.</h2>
      <form file="samochody-nowe" v-if="send == false">
        <div>
          <div class="c-form-row">
            <div class="c-form-item">
              <label>
                Imię <br>
                <input type="text" name="imie" value="" v-model="form.imie" :class="{ 'hasError': $v.form.imie.$error }">
              </label>
            </div>
            <div class="c-form-item">
              <label>
                Nazwisko <br>
                <input type="text" name="nazwisko" value="" v-model="form.nazwisko" :class="{ 'hasError': $v.form.nazwisko.$error }">
              </label>
            </div>
            <div class="c-form-item">
              <label>
                Numer telefonu <br>
                <input type="text" name="telefon" value="" v-model="form.telefon" :class="{ 'hasError': $v.form.telefon.$error }">
              </label>
            </div>
          </div>
          <div class="c-form-row">
            <div class="c-form-item">
              <label>
                Adres e-mail <br>
                <input type="text" name="email" value="" v-model="form.email" :class="{ 'hasError': $v.form.email.$error }">
              </label>
            </div>
            <div class="c-form-item">
              <label>
                Wybrany model<br>
                <input type="text" name="model" v-model="form.wybranymodel" disabled >
              </label>
            </div>
          </div>
          <br>&nbsp;<br>
          <div class="c-form-row">
            <div class="c-form-item" :class="{ 'hasError': $v.form.agreement1.$error }">
              <input type="checkbox" name="agreement1" id="agreement1" value="TAK" v-model="form.agreement1">
                <div class="accept-content">
                  <span>
                    Wyrażam zgodę na przetwarzanie przez Krotoski – Cichy sp. z o. o. sp. k. (KRS: 0000304253) danych osobowych wskazanych w powyższym formularzu w celach marketingowych. </span><span class="js-form-acept-toggle" v-on:click="toggleAccept(1)" v-if="visibleAccept[1]">[rozwiń całość]</span>
                    <span v-bind:class="{'accepthidden' : visibleAccept[1]}" >
                      Podanie moich danych osobowych było dobrowolne i świadome. Poinformowano mnie o przysługujących mi prawach, w szczególności o prawie cofnięcia zgody w każdym czasie, bez wpływu na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej wycofaniem.
                    </span>
                </div>
            </div>
          </div>
          <div class="c-form-row">
            <div class="c-form-item" :class="{ 'hasError': $v.form.agreement2.$error }">
                <input type="checkbox" name="agreement2" id="agreement2" value="TAK" v-model="form.agreement2">
                <div class="accept-content">
                  <span>
                    Wyrażam zgodę na wykorzystanie przez Krotoski – Cichy sp. z o. o. sp. k. (KRS: 0000304253) numeru telefonu dla celów przekazywania informacji marketingowej. </span><span class="js-form-acept-toggle" v-on:click="toggleAccept(2)" v-if="visibleAccept[2]">[rozwiń całość]</span>
                    <span v-bind:class="{'accepthidden' : visibleAccept[2]}">
                      Podanie moich danych osobowych było dobrowolne i świadome. Poinformowano mnie o przysługujących mi prawach, w szczególności o prawie cofnięcia zgody w każdym czasie, bez wpływu na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej wycofaniem.
                    </span>
                </div>
            </div>
          </div>
          <div class="c-form-row">
            <div class="c-form-item" :class="{ 'hasError': $v.form.agreement3.$error }">
                <input type="checkbox" name="agreement3" id="agreement3" value="TAK" v-model="form.agreement3">
                <div class="accept-content">
                  <span>
                    Wyrażam zgodę na otrzymywanie drogą elektroniczną na wskazany adres poczty elektronicznej informacji handlowych od Krotoski – Cichy sp. z o. o. sp. k. </span><span class="js-form-acept-toggle" v-on:click="toggleAccept(3)" v-if="visibleAccept[3]">[rozwiń całość]</span>
                    <span v-bind:class="{'accepthidden' : visibleAccept[3]}">
                      Podanie moich danych osobowych było dobrowolne i świadome. Poinformowano mnie o przysługujących mi prawach, w szczególności o prawie cofnięcia zgody w każdym czasie, bez wpływu na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej wycofaniem.
                    </span>
                </div>
            </div>
          </div>
          <div class="c-form-row">
            <div class="c-form-item" :class="{ 'hasError': $v.form.agreement4.$error }">
                <input type="checkbox" name="agreement4" id="agreement4" value="TAK" required="required" v-model="form.agreement4">
                <div class="accept-content">
                  Prosimy o potwierdzenie zapoznania się z poniższą informacją: <span class="js-form-acept-toggle" v-on:click="toggleAccept(4)"  v-if="visibleAccept[4]">[rozwiń całość]</span>
                  <span v-bind:class="{'accepthidden' : visibleAccept[4]}">
                    1. Współadministratorami Państwa danych osobowych zebranych w drodze powyższego formularza są:<br />
                    a) Krotoski-Cichy sp. z o. o. sp. k. z siedzibą w Łodzi, przy ul. Niciarnianej 51/53, legitymująca się numerem KRS: 0000304253, (dalej także jako Spółka). Dane kontaktowe Inspektora Ochrony Danych: ul. Niciarniana 51/53, 92-320 Łódź, e-mail: dane.osobowe@krotoskicichy.com, nr tel.: 785 012 459.<br />
                    b) Volkswagen Group Polska Sp. z o.o. legitymująca się numerem KRS: 0000327143, adres: ul. Krańcowa 44, 61-037 Poznań. Dane kontaktowe Inspektora Ochrony Danych: e-mail: iod@vw-group.pl lub pisemnie na w/w adres z dopiskiem "IOD". <br />

                    W przypadku wyrażenia jednej z powyższych zgód marketingowych, administratorem Państwa danych osobowych jest Krotoski-Cichy sp. z o. o. sp. k. z siedzibą w Łodzi, przy ul. Niciarnianej 51/53, legitymująca się numerem KRS: 0000304253, (dalej także jako Spółka).<br />
                    2. Wskazane wyżej dane osobowe są przetwarzane w celu przedstawienia oferty, na wniosek Klienta zgłoszony w przedmiotowym formularzu. W przypadku wyrażenia jednej z wyżej wskazanych zgód marketingowych, dane osobowe przetwarzane będą również w celu przekazywania informacji marketingowych i handlowych Spółki. Wyrażenie zgody na marketing jest dobrowolne, zgoda może zostać odwołana w dowolnym momencie w drodze wniosku złożonego drogą pisemną, telefoniczną lub e-mail na adresy wskazane w pkt. 1 a).<br />

                    3. Podstawa prawna przetwarzania: przetwarzanie odbywa się w celu podjęcia działań niezbędnych do zawarcia umowy (art. 6 lit. b RODO). W przypadku wyrażenia jednej z powyższych zgód marketingowych, przetwarzanie odbywa się w oparciu o Pani/Pana zgodę (art. 6 lit. a RODO). <br />

                    4. Dane osobowe będą przetwarzane do momentu:<br />
                    ·        odstąpienia od zamiaru zawarcia umowy lub w przypadku zawarcia umowy -  do chwili wygaśnięcia prawdopodobieństwa roszczeń (tj. do chwili przedawnienia roszczeń z umowy plus 1 rok powyżej tego terminu),<br />
                    ·        w przypadku wyrażenia zgody marketingowej, dane osobowe przetwarzane będą w celach marketingu do chwili odwołania zgody oraz dalej w celach dowodowych, do chwili prawdopodobieństwa wygaśnięcia roszczeń (tj. do chwili przedawnienia roszczeń plus 1 rok od tego terminu).<br />

                    5. Kategorie odbiorców danych osobowych:<br />
                    - podmioty wykonujące na rzecz Spółki zadania związane z administrowaniem strony internetowej; podmioty wykonujące na rzecz Spółki zadania związane z administrowaniem systemami teleinformatycznymi.<br />
                    - w przypadku wyrażenia jednej ze zgód marketingowych - podmioty realizujące dla Spółki określone czynności marketingowe, np. agencja reklamowa, organizator eventu, callcenter. <br />

                    6. Osoba, której dane osobowe są przetwarzane ma prawo dostępu do danych, ich sprostowania, usunięcia, ograniczenia przetwarzania, wniesienia sprzeciwu wobec przetwarzania oraz prawo do przenoszenia danych osobowych, z zastrzeżeniem, że prawo do przenoszenia danych osobowych dotyczy wyłącznie danych przetwarzanych w sposób wyłącznie zautomatyzowany. <br />

                    7. Osoba, której dane osobowe są przetwarzane ma prawo wniesienia skargi do właściwego organu nadzorczego. <br />

                    8. Podanie danych osobowych jest dobrowolne, jednak brak podania danych osobowych uniemożliwi przedstawienie oferty w drodze wniosku elektronicznego.<br />
                  </span>
                </div>
            </div>
          </div>
          <div class="text-red" v-if="$v.form.$error">
            Proszę wypełnić wszystkie wymagane dane
          </div>
          <button type="button" name="button" v-on:click="validate()">Wyślij</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { required, minLength, between, email, numeric } from 'vuelidate/lib/validators'


export default {
  name: 'Form',
  props:[
    'showForm',
    'modelName'
  ],
  data:function(){
    return{
      // showForm: true,
      visibleAccept: {
        0:true,
        1:true,
        2:true,
        3:true,
        4:true,
      },
      form: {
        imie:'',
        nazwisko:'',
        email:'',
        telefon:'',
        wybranymodel:'',
        agreement1:'',
        agreement2:'',
        agreement3:'',
        agreement4:''
      },
      send: false
    }
  },
  validations: {
    form: {
      imie: { required },
      nazwisko: { required },
      email: { required_if:{ function(){return (this.form.telefon || this.form.email) || false}}},
      telefon: { required_if:{ function(){return (this.form.email || this.form.telefon) || false}}},
      agreement1: { /*required_if:{ function(){return !( this.agreement1 || this.form.agreement2 || this.form.agreement3) || false}}*/ },
      agreement2: {},
      agreement3: {},
      agreement4: { required }
    }
  },
  methods:{
    toggleAccept: function(val){
      this.visibleAccept[val] = false
    },
    status(validation) {
      return {
        error: validation.$error,
        dirty: validation.$dirty
      }
    },
    validate () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        var that = this;
        var form_data = new FormData();

        for ( var key in this.form ) {

            form_data.append(key, this.form[key]);
        }
        this.axios.post('http://krotoskicichy.warszawa.audi.pl/include/form/samochody-nowe-lp-2019.php',
        form_data,
        {
          headers : {'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'}
        })
        .then(function (response) {
          that.send = true;
        }).catch(function (error) {
          window.alert(error);
        });

      }
    }
  },
  watch:{
    showForm: function(){
      this.$emit('showForm', false)
      this.send = false;
      this.form = {}
    },
    modelName: function(){
      this.form.wybranymodel = this.modelName;
    }
  },
  mounted:function(){


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.c-form-popup{
  &-wrap{
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, .75);
    display: flex;
    justify-content: center;
    flex-direction:column;
  }
  &-container{
    position: relative;
    background-color: #fff;
    max-width: 960px;
    max-height: 100vh;
    overflow: auto;
    margin: 0 auto;
    padding: 2rem;
    h2{
      font-size: 2rem;
    }
    h5{
      font-size: 1rem;
    }
    input[type=text]{
      border: 1px solid #000;
      padding: .5rem 1rem;
      width: 100%;
      margin-top: .5rem;
    }
    input[type=checkbox]{
      border: 1px solid #000;
    }
    button{
      padding: 1rem 2rem;
      border: 0;
      background-color: #000;
      color: #fff;
      cursor: pointer;
      margin: .5rem;
    }
  }
  &-close{
    position: absolute;
    top: 2rem;
    right: 2rem;
    width: 25px;
    height: 25px;
    background-color: #000;
    cursor: pointer;
    svg{
      fill: #fff;
    }
  }
}
.c-form-row{
  display: flex;
  justify-content: flex-start;
}
.c-form-item{
  width: 100%;
  margin: .5rem;
}
.js-form-acept-toggle{
    cursor: pointer;
    font-weight: bold;
}
.accept-content{
  width: 95%;
  float: right;
  margin-bottom: 1rem;
}
.accepthidden{
  display: none;
}

.hasError {
  border-color: red;
  background: #FDD;
}

.error:focus {
  outline-color: #F99;
}
.text-red{
  color: #c03;
  font-weight: bold;
  text-align: center;
}
</style>
